import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import questionApi from '../services/questionActions';
import { message } from 'antd';
import TopCrumb from '../components/TopCrumb';
import pdfIcon from '../images/login/pdf.png';
import { useSelector } from 'react-redux';
import { pdfFiles } from '../services/resourcesRender';
import ReactPlayer from 'react-player/lazy';

function Resources() {
  const [resources, setResources] = useState([]);

  const { module } = useSelector((state) => state.user);

  useEffect(() => {
    if (module) {
      const fetchResources = async () => {
        try {
          const res = await questionApi.getResources(module.id);
          console.log('res,resources ---', res);
          if (res) {
            setResources(res.data.data);
          }
        } catch (error) {
          if (error.response?.data.error) {
            message.error(error.response?.data.error);
          }
        }
      };
      fetchResources();
    }
  }, [module]);

  // console.log('module =====', module);

  const submitMaterialAction = (material_id) => {
    let data = {
      course_id: module.id,
      material_id: material_id,
    };

    const materialStatusUpdate = async () => {
      try {
        await questionApi.updateMaterialStatus(data);
      } catch (error) {
        // console.log('error', error);
        if (error.response?.data.error) {
          message.error(error.response?.data.error);
        }
      }
    };
    materialStatusUpdate();
  };

  return (
    <div className="container">
      <div className="py-4">
        <TopCrumb className="py-4" module={module} type="Resources" />
      </div>

      <div
        style={{ overflow: 'hidden' }}
        id="material-content"
        className="w-100 materials-bg px-3"
      >
        {resources.map((resource, idx) => {
          console.log('resource', resource);
          const module7 = resource?.course_id === '17';

          if (!module7) {
            return pdfFiles[resource.file].map((pdf, index) => {
              return (
                <a
                  onClick={() => submitMaterialAction(resource.id)}
                  key={idx}
                  href={pdf.url || pdf.pdf}
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: 'none', color: '#3b628d' }}
                  className="resource-link"
                >
                  <div className="my-3 material-content-bg cursor-pointer">
                    <div className="d-flex align-items-center p-2">
                      {pdf.pdf ? (
                        <img
                          style={{ width: '40px' }}
                          src={pdfIcon}
                          alt="pdf"
                        />
                      ) : null}
                      <h5 className="ms-4">{pdf.name} </h5>
                    </div>
                  </div>
                </a>
              );
            });
          } else {
            const module7Resources = pdfFiles[resource.file];

            return module7Resources.map((module7Res, index) => {
              if (module7Res.url) {
                return (
                  <a
                    onClick={() => submitMaterialAction(resource.id)}
                    key={idx}
                    href={module7Res.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: 'none', color: '#3b628d' }}
                    className="resource-link"
                  >
                    <div className="my-3 material-content-bg cursor-pointer">
                      <div className="d-flex align-items-center p-2">
                        <img
                          style={{ width: '50px' }}
                          src={pdfIcon}
                          alt="pdf"
                        />

                        <h5 className="ms-4">{module7Res.name} </h5>
                      </div>
                    </div>
                  </a>
                );
              } else if (module7Res.vimeoUrl) {
                return (
                  <div
                    onClick={() => submitMaterialAction(resource.id)}
                    key={idx}
                    style={{ textDecoration: 'none', color: '#3b628d' }}
                    className="resource-link"
                  >
                    <div className="my-3 material-content-bg cursor-pointer">
                      <div className="video-container mt-4 ">
                        <div className="video-wrapper">
                          <ReactPlayer
                            controls={true}
                            url={module7Res.vimeoUrl}
                            width="100%"
                            height={'100%'}
                            config={{
                              file: {
                                attributes: { controlsList: 'nodownload' },
                              },
                            }}
                            onContextMenu={(e) => e.preventDefault()}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            });
          }
        })}
      </div>
    </div>
  );
}

export default Resources;
